"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base = {
    100: '#FAFAFC',
    200: '#F0F1F7',
    300: '#CED0DD',
    400: '#9C9FB0',
    500: '#7C8195',
    600: '#666B7B',
    700: '#505462',
    800: '#3A3E47',
    900: '#25272D'
};
exports.default = base;
